/**
 * Feature flags for controlling application behavior
 */
export const featureFlags = {
  newAgentPage: true,
  enablePolling: true,
  enableWorkflows: true, // Workflow menu visible only to admins when enabled
  enableCreateTool: true, // Tool Forge menu and route controlled by admin config
  whiteLabelDemo: false, // Demo-only flag: uses a partner branding preset without changing tenant config
} as const;

export type FeatureFlagKey = keyof typeof featureFlags;
